import React from "react";

export function formatDate(d: Date): string {
    let result = "";
    if (d) {
        const date = new Date(d);
        result = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
    }
    return result;
};

export function formatStringColor(indicator: string): JSX.Element {
    return ( <span style={{ 
        color: ["A", "A+", "A-", "B+", "B", "B-"].includes(indicator) ? "green" : 
            ["C+", "C", "C-", "D+", "D", "D-"].includes(indicator) ? "#A75302" : "red"
     }}>{indicator}</span>);
}

export function formatNumberColor(indicator: number): JSX.Element {
    return ( <span style={{ color: indicator >= 90 ? "green" : indicator < 90 && indicator > 50 ? "#A75302" : "red" }}>{indicator}</span> );
}
